<div class="flex flex-col gap-2 sm:gap-4">
  @if (!!breadcrumbItems.length) {
    <app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>
  }
  <app-navigation-tabs
    [tabItems]="
      tabItemsSettings || tabItemsMailAccount || []
    "></app-navigation-tabs>
</div>
<router-outlet></router-outlet>
